import { t } from 'i18next';
import { WeatherCardDay } from './WeatherCardDay';
import { Wetter } from '@/gql/graphql';

export function WeatherCard({
  weatherOfTheDay,
}: {
  standortId: string | string[];
  weatherOfTheDay: Wetter[];
}) {
  return (
    <div>
      {!weatherOfTheDay ? (
        ''
      ) : (
        <>
          <div className="flex flex-row justify-between gap-4 grow">
            <WeatherCardDay weatherOfTheDay={weatherOfTheDay} />
          </div>
          <div className="gap-2 text-xs text-neutrals-700 py-3">
            {t('widgets.weather.wetterinfo')}
          </div>
        </>
      )}
    </div>
  );
}
